import React from 'react';
import './PopularBlog.css';
 
const PopularBlog = () => {
 


  return (
    <>
        {/* STRAT popularBlogMain */}
        <section className='popularBlogMain'>
            <div className='container'>
                {/* row start */}
                <div className="row">
                    <div className="col-lg-9 col-md-9 col-sm-12">
                        <div className="popularBlogHeading">
                            <h2>Explore In-Depth Insights on Rental Trends & Tips</h2>
                            <p>Explore our blog for valuable knowledge that helps you make the most of your rental experience!</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-12">
                        <div className="popularBlogBtn">
                            <a className="btn" href="/blogs">Discover more</a>
                        </div>
                    </div>
                </div>
                {/* row end */}

                {/* row start */}
                <div className="row">
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                        <div className="popularBlogInner">
                            <figure>
                                <img className="img-fluid" src="/img/blog/blog_4.jpg" alt="blog"/>
                            </figure>
                            <div className="popularDataAnounce">
                                <h3>The Unfortunate Fall of Getaround and HyreCar: What’s Next for Fleet Operators?</h3>
                                <p>For thousands of fleet operators and car-sharing hosts, the recent shutdown of 
                                    Getaround and HyreCar is more than just industry news—it’s deeply personal. It 
                                    represents lost income, broken trust, and an uncertain future for hardworking 
                                    individuals who built their businesses on these platforms. As the dust settles, 
                                    one pressing question remains: What’s next?</p>
                                <a href="/fleet-operators" className="btn">
                                    <span>Read more</span>
                                    <img src="/img/arrow_spl.svg" alt="icon"/>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                        <div className="popularBlogInner">
                            <figure>
                                <img className="img-fluid" src="/img/blog/blog_5.jpg" alt="blog"/>
                            </figure>
                            <div className="popularDataAnounce">
                                <h3>The Importance of Identity Verification in Car Rentals</h3>
                                <p>In the fast-paced world of car rentals, ensuring the safety and security of 
                                    both the business and its customers is of utmost importance.</p>
                                <a href="/identity-verification" className="btn">
                                    <span>Read more</span>
                                    <img src="/img/arrow_spl.svg" alt="icon"/>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                        <div className="popularBlogInner">
                            <figure>
                                <img className="img-fluid" src="/img/blog/blog_6.jpg" alt="blog"/>
                            </figure>
                            <div className="popularDataAnounce">
                                <h3>How to Optimize Your Vehicle Listing for Maximum Bookings</h3>
                                <p>In the world of car rental platforms, standing out is key to ensuring your vehicle gets 
                                    noticed and booked by potential renters.</p>
                                <a href="/maximum-booking" className="btn">
                                    <span>Read more</span>
                                    <img src="/img/arrow_spl.svg" alt="icon"/>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                        <div className="popularBlogInner">
                            <figure>
                                <img className="img-fluid" src="/img/blog/marketPlaceBanner.jpg" alt="blog"/>
                            </figure>
                            <div className="popularDataAnounce">
                                <h3>Thanks, Marketplaces. We’ll Take It From Here.</h3>
                                <p>The marketplace era is broken—and rental operators are done playing by someone else’s rules. For too long, platforms have profited off hosts while limiting their control, draining their margins, and forcing them into a one-size-fits-all system.</p>
                                <a href="/market-place" className="btn">
                                    <span>Read more</span>
                                    <img src="/img/arrow_spl.svg" alt="icon"/>
                                </a>
                            </div>
                        </div>
                    </div> */}

                </div>
                {/* row end */}

            </div>
        </section>
        {/* END popularBlogMain */}
    </>
  );
};

export default PopularBlog;
